<template>
    <div class="record-picker">
        <!-- pickerMode ile TableDetail bileşenini modül modunda kullanıyoruz.
             "record-selected" event'i ile seçilen kaydı üst bileşene iletiyoruz. -->
        <TableDetail
            :defaultTableId="tableId"
            :moduleMode="true"
            :default-linked-record-cache="{}"
            :pickerMode="true"
            @record-selected="onRecordSelected"
        />
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    name: "RecordPicker",
    components: {
        TableDetail: () => import("../TableDetail.vue"),
    },
    props: {
        tableId: {
            type: String,
            required: true,
        },
        /*
          Eğer etiket alanı ID'sine ihtiyacınız varsa,
          buraya labelFieldId vb. ek prop tanımlayabilirsiniz.
        */
    },
    methods: {
        /**
         * TableDetail içinde bir kaydı seçtiğimizde tetiklenecek metod.
         * Üst bileşene "record-selected" event'i gönderiyoruz.
         */
        onRecordSelected(record) {
            this.$emit("record-selected", record);
        },
    },
});
</script>

<style scoped lang="scss">
.record-picker {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}
</style>
